'use strict';

import 'babel-polyfill';
// import 'whatwg-fetch';
// impot library
import {
  TweenMax,
  TweenLite
} from 'gsap';
import ScrollMagic from 'scrollmagic'
import 'animation.gsap'
import 'slick-carousel'
// import 'particles.js'
// import 'parsleyjs'
// import 'parsleyjs/dist/i18n/ja.js'
// import 'ScrollMagicGSAP'
// import ScrollToPlugin from 'ScrollToPlugin';
// import EasePack from 'EasePack';
// import modernizr from 'modernizr';
//
// console.log(modernizr);

import Utils from './class/Utils.js';
// window.Parsley.setLocale('ja');
$(() => {
  $(".pc header").css("width",window.innerWidth);
  $(".pc header").css("height",window.innerHeight);
  $(".pc header").css("left", $(window).scrollLeft());
  $(window).on("scroll", function(){
      $(".pc header").css("left", $(window).scrollLeft());
  });
  $(window).on("resize", function(){
    $(".pc header").css("width",window.innerWidth);
    $(".pc header").css("height",window.innerHeight);
    $(".pc header").css("left", $(window).scrollLeft());
  });

  $("a[href^='#']").click(function() {
    var speed = 400;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("body,html").animate({scrollTop:position}, speed, "swing");
    return false;
  });

  var controller = new ScrollMagic.Controller();
  add_tween(controller,"nav .illust","nav", TweenMax.fromTo("nav .illust", 0.4,{opacity: 0, x: 100},{opacity: 1, x: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#illust1","#matsuho", TweenMax.fromTo("#illust1", 0.4,{opacity: 0, y: -100},{opacity: 1, y: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#matsuho .haiku","#matsuho .haiku", TweenMax.fromTo("#matsuho .haiku", 0.4,{opacity: 0, y: 100},{opacity: 1, y: 0 , ease: Ease.easeOut}) ,"onEnter");
  add_tween(controller,"#illust2-1","#teyaki", TweenMax.fromTo("#illust2-1", 0.4,{opacity: 0, x: -100},{opacity: 1, x: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#illust2-2","#teyaki", TweenMax.fromTo("#illust2-2", 0.4,{opacity: 0, y: -100},{opacity: 1, y: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#illust3","#tuyatuke", TweenMax.fromTo("#illust3", 0.4,{opacity: 0, x: -100},{opacity: 1, x: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#illust4-1","#kiji", TweenMax.fromTo("#illust4-1", 0.4,{opacity: 0, y: 100},{opacity: 1, y: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#illust4-2","#kiji", TweenMax.fromTo("#illust4-2", 0.4,{opacity: 0, x: 100},{opacity: 1, x: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#illust5-1","#koujimiso", TweenMax.fromTo("#illust5-1", 0.4,{opacity: 0, y: -100},{opacity: 1, y: 0 , ease: Ease.easeOut}) );
  add_tween(controller,"#illust5-2","#koujimiso", TweenMax.fromTo("#illust5-2", 0.4,{opacity: 0, x: 100},{opacity: 1, x: 0 , ease: Ease.easeOut}) );
  // add_tween(controller,".bottom-illust","#senbei1");

  add_tween(controller,"#illust2","#illust2", TweenMax.fromTo("#illust2", 0.4,{opacity: 0, y: 100},{opacity: 1, y: 0 , ease: Ease.easeOut}) ,"onCenter");
  add_tween(controller,"#illust4","#illust4", TweenMax.fromTo("#illust4", 0.4,{opacity: 0, y: 100},{opacity: 1, y: 0 , ease: Ease.easeOut}) ,"onCenter");
  add_tween(controller,"#illust5","#illust5", TweenMax.fromTo("#illust5", 0.4,{opacity: 0, y: 100},{opacity: 1, y: 0 , ease: Ease.easeOut}) ,"onCenter");

  var tween = TweenMax.fromTo(".black-shadow", 0.5,
    {opacity: 1},
    {opacity: 0 , ease: Ease.easeOut}
  );
  var scene = new ScrollMagic.Scene({triggerElement: "header img.copy", triggerHook: "onLeave"})
    .setTween(tween)
    .addTo(controller);


  var tween = TweenMax.fromTo(".bottom-illust", 0.5,
    {opacity: 0, bottom: -100},
    {opacity: 1, bottom: -15 , ease: Back.easeOut.config(2)}
  );
  var scene = new ScrollMagic.Scene({triggerElement: "#senbei1 .photo", triggerHook: "onEnter"})
    .setTween(tween)
    .addTo(controller);

  var scene = new ScrollMagic.Scene({triggerElement: ".shops", triggerHook: "onEnter"})
    .setClassToggle(".back", "orange")
    .addTo(controller);

  $('.pc .slides').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false
  });

  $('.sp .slides').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    arrows: true,
    centerPadding: 0,
    prevArrow: '<div class="slick-prev"></div>',
    nextArrow: '<div class="slick-next"></div>',
    pauseOnHover: false,
    pauseOnFocus: false
  });
});

function add_tween(controller,target,trigger, tween, triggerhook){
  var triggerhook = triggerhook || "onCenter";
  var tween = tween || TweenMax.fromTo(target, 0.3,
    {opacity: 0, scale: 0},
    {opacity: 1, scale: 1 , ease: Back.easeOut.config(1.7)}
  );
  var scene = new ScrollMagic.Scene({triggerElement: trigger, triggerHook: triggerhook})
    .setTween(tween)
    .addTo(controller);
}



// WEBPACK FOOTER //
// app/src/assets/js/script.js